import { AxiosResponse } from 'axios';

import { GetConsultationDetailsPayload } from '@Services/Order/order-payload';
import { DRUG_PICKUP_PINCODE } from '@Utils/constants/rx';
import { InvoiceStatus } from '@Utils/Helpers/Order/helper';

import { Axios } from '../AxiosApiServerWrapper';

export const OrderService = {
  GetConsultationDetails: async (payload: GetConsultationDetailsPayload): Promise<AxiosResponse> => {
    const { consultationCode, locationId } = payload;
    const locationParam = locationId ? `?locationId=${locationId}` : '';
    const url = `catalog/consultation/code/${consultationCode}${locationParam}`;
    return Axios.Request({ methodType: 'GET', url });
  },
  GetInvoiceForEncounter: async (payload: { encounterId: string }): Promise<AxiosResponse> => {
    const { encounterId, ...body } = payload;
    const url = `fx/shipping/encounters/${encounterId}`;
    return Axios.Request({ methodType: 'GET', url, params: body });
  },
  GetPatientInvoices: async (payload: { statuses?: InvoiceStatus[]; encounterId?: string }): Promise<AxiosResponse> => {
    const url = 'invoices';
    return Axios.Request({ methodType: 'GET', url, params: payload });
  },
  GetConsultationOrders: async (patientId, take = 25): Promise<AxiosResponse> => {
    const url = `consultations`;
    return Axios.Request({ methodType: 'GET', url, params: { patientId, take }, skipIpxId: true });
  },
  GetConsultationOrdersFromInvoice: async (invoiceId): Promise<AxiosResponse> => {
    const url = `fulfilment/invoices/${invoiceId}/consultations`;
    return Axios.Request({ methodType: 'GET', url });
  },
  GetLabTestOrders: async (): Promise<AxiosResponse> => {
    const url = `fx/lab/orders`;
    return Axios.Request({ methodType: 'GET', url });
  },
  GetPendingOrders: async (payload: { showArticles?: boolean }): Promise<AxiosResponse> => {
    const { showArticles } = payload;
    const url = `encounters/dashboard-items`;
    return Axios.Request({ methodType: 'GET', url, params: { showArticles } });
  },
  UpdateMedicineOrderAddress: async (payload: { fulfillmentId: string; addressId: string }): Promise<AxiosResponse> => {
    const { fulfillmentId, addressId } = payload;
    const url = `fx/drug/${fulfillmentId}/confirm-address`;
    return Axios.Request({ methodType: 'POST', url, payload: { toAddressId: addressId } });
  },
  GetDeliveryEstimates: async (payload: { delivery_postcode: number; weight: number }): Promise<AxiosResponse> => {
    const url = `vendors/shiprock/serviceability`;
    return Axios.Request({ methodType: 'GET', url, params: { ...payload, pickup_postcode: DRUG_PICKUP_PINCODE } });
  },
};
